import { Outlet } from "react-router-dom";
import { ContentColumn } from "../../components/Content";

export default function DemoLayout() {
    return <ContentColumn className={"w-full"}>
        <Outlet />
    </ContentColumn>
}